import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Mientras carga (verificando token), no renderizamos nada o mostramos un spinner
  if (loading) {
    return <div>Cargando...</div>; // O un componente de spinner
  }

  // Si no está autenticado, redirigimos a la página de login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  // Si está autenticado, renderizamos los componentes hijos de la ruta
  // Outlet se usa cuando PrivateRoute es un Route padre en React Router v6
  return children ? children : <Outlet />;
};

export default PrivateRoute;
